import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useEquipmentItem } from '../api/queries'
import { EquipmentLabel } from '../components/EquipmentLabel'
import {
  LabelMediaPicker,
  LabelPageStyle,
  RollPrintHint,
  labelSheetClass,
  useLabelMedia
} from '../components/LabelPrint'
import { ErrorBox, Loading } from '../components/ui'

/**
 * Printvenlig side med QR-mærkatet til et stykke værktøj (beslutning 096).
 *
 * Samme opsætning som enhedernes mærkater: alt uden for selve mærkaterne
 * forsvinder ved print (@media print i styles.css), og antallet af kopier kan
 * skrues op - et mærkat på en boremaskine i en varevogn holder ikke evigt.
 */
export function EquipmentLabelPage() {
  const { id } = useParams()
  const equipmentId = Number(id)
  const { data: item, isLoading, error } = useEquipmentItem(equipmentId)
  const [copies, setCopies] = useState(1)
  const [media, setMedia] = useLabelMedia()

  // Titlen bliver til filnavnet, hvis nogen printer til PDF.
  useEffect(() => {
    const previous = document.title
    document.title = 'Værktøjsmærkat'
    return () => {
      document.title = previous
    }
  }, [])

  if (isLoading) return <Loading />
  if (error) return <ErrorBox error={error} />
  if (!item) return <ErrorBox error={new Error('Værktøjet findes ikke.')} />

  return (
    <>
      <div className="row no-print" style={{ marginBottom: 16, flexWrap: 'wrap' }}>
        <Link className="btn btn--sm" to={`/equipment/${item.id}`}>
          Tilbage
        </Link>

        <label className="row small muted" style={{ gap: 6 }}>
          Kopier
          <input
            type="number"
            min={1}
            max={10}
            style={{ width: 70 }}
            value={copies}
            onChange={(event) => setCopies(Math.min(10, Math.max(1, Number(event.target.value) || 1)))}
          />
        </label>

        <LabelMediaPicker media={media} onChange={setMedia} />

        <button className="btn btn--primary btn--sm" onClick={() => window.print()}>
          Print
        </button>

        <span className="tiny muted">
          Sæt mærkatet et sted, hvor det ikke slides af - koden {item.code} kan også tastes ind i
          hånden.
        </span>
      </div>

      <LabelPageStyle media={media} />
      <RollPrintHint media={media} />

      <div className={labelSheetClass(media)}>
        {Array.from({ length: copies }, (_, copy) => (
          <EquipmentLabel key={copy} item={item} />
        ))}
      </div>
    </>
  )
}
